let abortController = null;

export function initCollapsibleContent() {
    if (abortController) {
        abortController.abort();
    }

    abortController = new AbortController();
    const { signal } = abortController;

    const container = document.getElementById('collection-sidebar-container');
    const overlay = document.getElementById('collection-expand-overlay');
    const btn = document.getElementById('collection-expand-btn');

    if (!container || !overlay || !btn) {
        return;
    }

    // Check if content exceeds max-height
    const checkOverflow = function () {
        const maxHeight = window.innerWidth >= 992 ? 1200 : 700;
        if (container.scrollHeight <= maxHeight) {
            overlay.classList.add('hidden');
            container.classList.add('expanded');
        }
    };

    checkOverflow();

    window.addEventListener('resize', checkOverflow, { signal });

    btn.addEventListener(
        'click',
        () => {
            container.classList.add('expanded');
            overlay.classList.add('hidden');
        },
        { signal }
    );
}

export function collapsibleContentListener() {
    initCollapsibleContent();
}
